import React, { useEffect, useState } from "react";
import "./professionSuggestion.css";
import API from "../../../api";

export default function ProfessionSuggestionRow() {
  const [list, setList] = useState([]);

  const loggedInUser = JSON.parse(
    localStorage.getItem("civilink_user")
  );

  

  const [connectedUsers, setConnectedUsers] = useState(
    loggedInUser?.connections || []
  );

  useEffect(() => {
    fetch("/api/profession/suggested/home")
      .then(res => res.json())
      .then(data => {
        if (data.success) setList(data.users);
      });
  }, []);

  /* ================= CONNECT USER ================= */
  const connectUser = async (targetUserId) => {
   

    try {
      const res = await API.post(
  `/connections/${targetUserId}/connect`
);

if (res.data.success) {
  setConnectedUsers(prev => [...prev, targetUserId]);

  const updatedUser = {
    ...loggedInUser,
    connections: [
      ...(loggedInUser.connections || []),
      targetUserId
    ]
  };

  localStorage.setItem(
    "civilink_user",
    JSON.stringify(updatedUser)
  );
}
    } catch (err) {
  console.error("Connect failed", err);

  alert(
    err.response?.data?.message ||
    "Unable to connect. Please try again."
  );
}
  };

  if (!list.length) return null;

  return (
    <div className="profession-suggest-row">
      <h4>Suggested Professionals</h4>

      <div className="suggest-scroll">
        {list.map(u => {
          const isConnected =
            connectedUsers.includes(u._id);

          return (
            <div key={u._id} className="suggest-card">
              <div className="avatar">
                {u.profilePhoto ? (
                  <img src={u.profilePhoto} alt="" />
                ) : (
                  u.name.charAt(0)
                )}
              </div>

              <div className="info">
                <strong>{u.name}</strong>
                <span>{u.profession}</span>
              </div>

              <button
                className={`connect-btn ${
                  isConnected ? "connected" : ""
                }`}
                disabled={isConnected}
                onClick={() => connectUser(u._id)}
              >
                {isConnected ? "Connected" : "Connect"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
